import { render, staticRenderFns } from "./goldData.vue?vue&type=template&id=1f93047a&scoped=true"
import script from "./goldData.vue?vue&type=script&lang=js"
export * from "./goldData.vue?vue&type=script&lang=js"
import style0 from "./goldData.vue?vue&type=style&index=0&id=1f93047a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f93047a",
  null
  
)

export default component.exports